export const getTitle = (title: string) => {
  switch (title) {
    case 'withdraw_confirmation':
      return 'Withdrawal Confirmation';
    case 'bank_account_confirmation':
      return 'Bank Account Confirmation';
    default:
      return null;
  }
};

export const getGuardMessage = (key: string) => {
  switch (key) {
    case 'not_investing':
      return 'You can not select this option, you already have active investments.';
    default:
      return null;
  }
};
